import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { DocumentationRequestEmailEditTemplate } from 'themes/application/documentation-request/pages';
import { DocumentationRequestEmailEditViewStore } from 'application/documentation-request/stores';

@setCurrentView((rootStore) => new DocumentationRequestEmailEditViewStore(rootStore), 'documentationRequestEmailEditViewStore')
@observer
class DocumentationRequestEmailEdit extends React.Component {
    render() {
        return <DocumentationRequestEmailEditTemplate {...this.props} />
    }
}

export default DocumentationRequestEmailEdit;
